module.exports = __webpack_public_path__ + "images/9ae8c9e632d494d55fcb576792cf60cb-hub_placement_full_screen.png";